export default __webpack_public_path__ + "static/media/habibers.27549df5.png";